import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExclamationInCircleWhite = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.5 6C11.5 9.03757 9.03757 11.5 6 11.5C2.96243 11.5 0.5 9.03757 0.5 6C0.5 2.96243 2.96243 0.5 6 0.5C9.03757 0.5 11.5 2.96243 11.5 6ZM6.6875 2.5625L6.6875 7.04199H5.3125L5.3125 2.5625L6.6875 2.5625ZM6 9.65234C6.4936 9.65234 6.89375 9.2522 6.89375 8.75859C6.89375 8.26499 6.4936 7.86484 6 7.86484C5.5064 7.86484 5.10625 8.26499 5.10625 8.75859C5.10625 9.2522 5.5064 9.65234 6 9.65234Z",
		fill: "white"
	})]
});
const ForwardRef = forwardRef(SvgExclamationInCircleWhite);
export { ForwardRef as ReactComponent };
